import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";
import { Venue } from "../../../site-visit/types/site-visit";

interface AssignedSiteVisitsWidgetProps {
  userName: string;
  assignedVisits: Venue[];
  isLoading: boolean;
  onViewAll?: () => void;
}

const AssignedSiteVisitsWidget: React.FC<AssignedSiteVisitsWidgetProps> = ({
  userName: _userName,
  assignedVisits,
  isLoading,
  onViewAll,
}) => {
  void _userName;
  const filteredVisits = assignedVisits
    .filter((visit) => visit.dueDate !== undefined)
    .sort(
      (a, b) =>
        new Date(a.dueDate as string).getTime() -
        new Date(b.dueDate as string).getTime()
    )
    .slice(0, 5);

  return (
    <Paper
      sx={{
        p: 2,
        boxShadow: 0,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        borderRadius: 3,
      }}
    >
      <Typography variant="h5" color="text.secondary">
        Here are your upcoming site visits:
      </Typography>

      {/* Loading state */}
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : filteredVisits.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          You currently have no upcoming site visits.
        </Typography>
      ) : (
        <List>
          {filteredVisits.map((visit, index) => (
            <React.Fragment key={visit.id}>
              <ListItem
                sx={{
                  alignItems: "flex-start",
                  px: 0,
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                      {visit.name}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography
                        variant="body2"
                        component="span"
                        color="text.secondary"
                      >
                        📍 {visit.address}
                      </Typography>
                      <br />
                      <Typography
                        variant="body2"
                        component="span"
                        color="text.secondary"
                      >
                        📅 {visit.dueDate}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              {index < filteredVisits.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      )}

      {/* Footer Action */}
      {assignedVisits.length > 5 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            size="small"
            variant="outlined"
            onClick={onViewAll}
            sx={{ borderRadius: 2 }}
          >
            View All
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default AssignedSiteVisitsWidget;
